//language=HTML,js
import {Modal} from 'bootstrap';
import {v4 as uuid} from 'uuid';

const fetchLink = (e) => {
    if (e.button !== 0 && e.button !== 1) {
        return;
    }
    const link = e.target.closest('[data-fetch="link"]');
    if (link) {
        const url = link.href || link.dataset.url;
        if (!url) {
            return;
        }
        e.preventDefault();
        if (e.ctrlKey || e.button === 1) {
            window.open(url);
        } else {
            window.location.href = url;
        }

    }
}
document.body.addEventListener('click', fetchLink);
document.body.addEventListener('auxclick', fetchLink);

const fetchModal = e => {
    if (e.button !== 0 && e.button !== 1) {
        return;
    }
    const link = e.target.closest('[data-fetch="modal"]');
    if (!link) {
        return;
    }
    const url = link.getAttribute('href') ?? link.dataset.url;
    if (!url) {
        return;
    }
    e.preventDefault();

    if (e.type === 'mousedown' || (e.type === 'mouseup' && e.button === 0)) {
        return;
    }

    if (e.ctrlKey || e.button === 1) {
        window.open(url);
    } else {
        e.preventDefault();

        let title = link.dataset.title ?? link.textContent;
        let size = link.dataset.modalSize ?? 'lg';

        let id = 'Modal-' + uuid();

        const loader = `
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div
                            class="d-flex justify-content-center align-items-center"
                            style="height: 90vh"
                        >
                            <div
                                class="spinner-grow"
                                style="width: 3rem;height: 3rem;"
                                role="status"
                            >
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>`;

        const content = document.createElement('div');
        content.innerHTML = `
                <div
                    class="modal fade"
                    id="${id}"
                    tabindex="-1"
                    aria-labelledby="${id}Label"
                    aria-hidden="true"
                >
                    ${loader}
                </div>`;

        document.body.appendChild(content.firstElementChild);

        const modal = new Modal(`#${id}`);
        modal.show();

        const layout = "Icing.modal";

        fetch(url, {
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                "X-Layout": layout
            }
        })
            .then(r => r.text())
            .then(content => {
                const container = document.getElementById(id);
                document.getElementById(id).innerHTML = content;

                const scripts = document.getElementById(id).getElementsByTagName('script');
                for (let i = 0; i < scripts.length; i++) {
                    const script = scripts[i];
                    const newScript = document.createElement('script');

                    // Copy all attributes.
                    for (let j = 0; j < script.attributes.length; j++) {
                        const attr = script.attributes[j];
                        newScript.setAttribute(attr.name, attr.value);
                    }

                    // Copy the script's content.
                    newScript.appendChild(document.createTextNode(script.innerHTML));

                    // Replace the old script tag with the new one.
                    script.parentNode.replaceChild(newScript, script);
                }

            });
    }
};
document.addEventListener('click', fetchModal);
//document.addEventListener('auxclick', fetchModal);
document.addEventListener('mousedown', fetchModal);
document.addEventListener('mouseup', fetchModal);



